import './FormView.scss';
import Http from 'components/http/Http';
import FormDisplay from 'components/chrome/FormDisplay';
import React from 'react';
import { withRouter } from 'react-router';


const FORM_PREFIX = '/form';


class FormView extends React.Component {
  constructor() {
    super();
    this.http = new Http.Factory().create();
    this.state = { loaded: false, fields: {} };
  }

  async _getForm() {
    let result;
    try {
      result = await this.http.get(FORM_PREFIX + this.path);
    } catch(error) {
      switch (error.status) {
        case 404:
          this.setState({ loaded: true, content: 'Content not found.' });
          break;
        default:
          this.setState({ loaded: true, content: 'Unknown error occurred.' });
      }
      return;
    }
    this.setState({ loaded: true, content: (result.body)});
  };

	onFieldUpdate(name, value) {
    let fieldUpdate = {};
    fieldUpdate[name] = value;
    fieldUpdate = Object.assign({}, this.state.fields, fieldUpdate);
    this.setState({ fields: fieldUpdate });
	}

  async onSubmit(data) {
    let result;
    try {
      result = await this.http.post(FORM_PREFIX + this.path)
          .set('X-CSRFToken', data.csrf_token)
          .send(data);
    } catch(error) {
      console.log(error.status);
      console.log(error);
      return;
    }
    const success = result.body && result.body.success;
    if (success && this.props.formNext) {
      this.setState({
        loaded: true,
        redirect: this.props.formNext,
      });
      this.props.history.push(this.state.redirect);
    } else {
      this.setState({ content: result.body });
    }

    // TODO: handle other values of result.statusCode
  }

  renderForm() {
    if (this.state.content) {
      return <FormDisplay
          {...this.state.content}
          parentState={this.state.fields}
          msg={this.state.content.msg}
          onUpdate={this.onFieldUpdate.bind(this)}
          onSubmit={this.onSubmit.bind(this)} />;
    }
  }

  render() {
    if (!this.path) {
      this.path =
          this.props.formPath ||
          '/' + this.props.match.params.formPath.replace(/-/g, '/');
    }

    if (!this.state.loaded) {
      this._getForm();
    }

    return (
      <div className='page-form'>{this.renderForm()}</div>
    );
  }
}


export default withRouter(FormView);
